import { render } from "./DatePicker.vue?vue&type=template&id=2cb8c89e&scoped=true"
import script from "./DatePicker.vue?vue&type=script&lang=ts"
export * from "./DatePicker.vue?vue&type=script&lang=ts"

import "./DatePicker.vue?vue&type=style&index=0&id=2cb8c89e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2cb8c89e"

export default script